import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Intermodal from "./Intermodal";

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/intermodal" element={<Intermodal />} />
      <Route path="*" element={<Navigate replace to={"/intermodal"} />} />
    </Routes>
  );
};

export default AppRouter;
